import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { OrderInBatch, PrintBatchData } from '@app/services/batches/print-batches';
import { PrintService } from '../../services/print.service';
import { OrderBatchService } from '@app/services/order-batch/order-batch.service';
import { FulfillService } from '@app/pages/workspace/fulfill/fulfill.service';
import { VoidModalComponent } from '@app/pages/workspace/fulfill/components/fulfill-back-to-assign-btn/components/void-modal/void-modal.component';
@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-back-to-assign-btn',
  templateUrl: './back-to-assign-btn.component.html',
  styleUrls: ['./back-to-assign-btn.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BackToAssignBtnComponent {
  @Input() batch: PrintBatchData;
  @Input() batchStatus: 'running' | 'printing' | 'recentlyDone';
  @Input() order: OrderInBatch;
  @Input() disableBackToAssign;
  @Input() label;
  @Input() scope: 'batch' | 'orders';
  @Output() orderMoved = new EventEmitter<OrderInBatch>();
  loading = false;
  isOrder: boolean = false;
  isCarrierHaveCancelSupport: boolean = false;
  orderIdForDialog: string = '';
  orderIdsForDialog: string[] = [];
  isCancel: boolean = false;

  constructor(
    private dialog: MatDialog,
    private printService: PrintService,
    private orderBatchService: OrderBatchService,
    private fulfillService: FulfillService,
  ) {}

  backToAssign(): void {
    //check if carrier have cancel support
    if (this.order) {
      this.orderIdForDialog = this.order.orderNumber;
      this.isOrder = true;
      this.orderBatchService.checkBatchCarrierValid(this.batch.id).then((res) => {
        if (res) {
          this.isCancel = true;
          this.openOrderAndBatchAssignModal();
        } else {
          this.isCancel = false;
          this.openOrderAndBatchAssignModal();
        }
      });
    } else {
      //check for batch carrier support
      this.orderBatchService.checkBatchCarrierValid(this.batch.id).then((res) => {
        this.isOrder = false;
        this.batch.orders.map((order) => {
          if (this.orderIdsForDialog.indexOf(order.orderNumber) === -1) {
            this.orderIdsForDialog.push(order.orderNumber);
          }
        });
        if (res) {
          this.isCancel = true;
          this.openOrderAndBatchAssignModal();
        } else {
          this.isCancel = false;
          this.openOrderAndBatchAssignModal();
        }
      });
    }
  }

  openOrderAndBatchAssignModal(): void {
    const dialogRef = this.dialog.open(VoidModalComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'overflow-visible-class',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: {
        scope: this.scope,
        batch: this.batch,
      },
    });
    if (this.isOrder) {
      dialogRef.afterClosed().subscribe(() => {
        this.fulfillService.initLoadBatches();
        this.fulfillService.togglePanel(false);
        this.orderMoved.next(this.order);
      });
    } else {
      dialogRef.afterClosed().subscribe(() => {
        this.fulfillService.initLoadBatches();
        this.fulfillService.togglePanel(false);
      });
    }
  }
}
